import {FaGetPocket, FaLine} from 'react-icons/fa';
import {FaXTwitter} from 'react-icons/fa6';
import {MdFacebook} from 'react-icons/md';
import {
  createFacebookShareUrl,
  createHatenaShareUrl,
  createLineShareUrl,
  createPocketShareUrl,
  createXShareUrl,
} from '../../../../core/factories/shared/createShareUrl';

export const ShareButtonsForDrill: React.FC<{
  title: string;
  currentUrl: string;
}> = ({title, currentUrl}) => {
  return (
    <div className="bg-white flex space-x-8 p-[30px] items-center justify-center">
      <a
        className="bg-sns-facebook-blue w-[52px] pc:w-[100px] h-36 pc:hover:opacity-80 rounded-4 flex justify-center items-center"
        href={createFacebookShareUrl({currentUrl})}
        target="_blank"
        rel="noreferrer"
      >
        <MdFacebook className="text-white" />
      </a>
      <a
        className="bg-sns-x-black text-white w-[52px] pc:w-[100px] h-36  pc:hover:opacity-80 rounded-4 flex justify-center items-center"
        href={createXShareUrl({currentUrl, title})}
        target="_blank"
        rel="noreferrer"
      >
        <FaXTwitter size={20} />
      </a>
      <a
        className="bg-sns-hatena-bule text-white w-[52px] pc:w-[100px] h-36  pc:hover:opacity-80 rounded-4 flex justify-center items-center"
        href={createHatenaShareUrl({currentUrl})}
        target="_blank"
        rel="noreferrer"
      >
        B!
      </a>
      <a
        className="bg-sns-line-green text-white w-[52px] pc:w-[100px] h-36 pc:hover:opacity-80 rounded-4 flex justify-center items-center"
        href={createLineShareUrl({currentUrl, title})}
        target="_blank"
        rel="noreferrer"
      >
        <FaLine size={20} />
      </a>
      <a
        className="bg-sns-pocket-red text-white w-[52px] pc:w-[100px] h-36 pc:hover:opacity-80 rounded-4 flex justify-center items-center"
        href={createPocketShareUrl({currentUrl, title})}
        target="_blank"
        rel="noreferrer"
      >
        <FaGetPocket />
      </a>
    </div>
  );
};
